module.exports = __webpack_public_path__ + "assets/img/9d284701101a1e8ec1da54254d385849.webp";